import React, { Component } from 'react';
 import "./publicNav.css"
import {
    Link,
  } from 'react-router-dom'
  
class Publicnav extends Component {
    // constructor(props){
    //     super(props)

    // }

    constructor(props) {
      super(props);
  
      this.state = {};
  
      this.handleScroll = this.handleScroll.bind(this);
    }
  
    handleScroll() {
      console.log(" window.scrollY window.scrollY",  window.scrollY)
      this.setState({scroll: window.scrollY});
      if(window.scrollY  >= 160.8000030517578){
        this.props.closenav(true)
        console.log("yes")
      }else{
        this.props.closenav(false)
        console.log("no")  
      }

    }
    
    componentDidMount() {
      const el = document.querySelector('nav');
      this.setState({top: el.offsetTop, height: el.offsetHeight});
      window.addEventListener('scroll', this.handleScroll);
    }
    
    componentDidUpdate() {
      this.state.scroll > this.state.top ? 
        document.body.style.paddingTop = `${this.state.height}px` :
        document.body.style.paddingTop = 0;
    }
    
    render() {
      return (
        <div className='public-nave-ban' style={{"z-index":"4000"}}>
        <nav className={this.state.scroll > this.state.top ? "sticky" : ""}>
        <div class="navbar-start  navbar-start-pubbli-nav">
          <a class="navbar-item" href="/home/jktrgkslrtsetgstegkst">
            Home
          </a>
          <a class="navbar-item" href="/about/jktrgkslrtsetgstegkst">
            About
          </a>
          <a class="navbar-item" href="/contact/jktrgkslrtsetgstegkst">
          Contact
          </a>
         </div> 
          <ul className="public-nave-ban-sub">
            <li> <a class="navbar-item" href="/home/jktrgkslrtsetgstegkst">Home</a></li>
            <li><a  class="navbar-item" href="/about/jktrgkslrtsetgstegkst">About</a></li>
       
            <li><a  class="navbar-item" href="/contact/jktrgkslrtsetgstegkst">Contact</a></li>
         
          </ul>
        </nav>

        </div>
      );
    // }

  // render() {
  //   console.log("props id",this.props.id)
  //   return (

  //             <div className='public-nave-ban'>
              
 

           
  //             </div>
              // <div className="search-body">
              //       <ul className="home-body-link">
              //           <li className="home-sub-link"><Link to={`/home/${this.props.id}`}  className="active" href="#home">Home</Link></li>
              //           {/* <li className="home-sub-link"><Link to={`/admission/${this.props.id}`} > Admission </Link></li> */}
              //           <li className="home-sub-link"><Link to={`/contact/${this.props.id}`} >Contact </Link></li>
              //           <li className="home-sub-link"><Link to={`/about/${this.props.id}`} >About</Link></li>
              //           <li className="home-sub-link"><Link to={`/news/${this.props.id}`} >News</Link></li>
              //       </ul>
              // </div> 
       
            

    // )

}





}

export default Publicnav;


// WEBPACK FOOTER //
// ./src/component/public/publicNav.js